const FACTORY_ASSET_HOST = 'faterstoragefrance.blob.core.windows.net';

export const isAllowedFactoryReferenceUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && url.hostname === FACTORY_ASSET_HOST;
  } catch {
    return false;
  }
};
